/* Organic Fiber theme: bag, wishlist, sections and finishing touches */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var S = window.OFSound;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var money = function (cents) { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: OF.currency }); };
  var load = function (k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (err) { return []; } };
  var save = function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (err) {} };

  /* Page-change line */
  var rl = $('#routeLine'); if (rl && !still) rl.classList.add('go');

  /* Drawers */
  var scrim = $('#scrim');
  function closeAll() {
    $$('.drawer').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('on');
  }
  function open(d) {
    if (!d) return;
    closeAll(); d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); scrim.classList.add('on');
    var x = $('.x', d); if (x) x.focus();
  }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  var menuBtn = $('#menuBtn'); if (menuBtn) menuBtn.addEventListener('click', function () { open($('#mDrawer')); });
  $$('.mnav a').forEach(function (a) { a.addEventListener('click', closeAll); });

  /* Bag */
  var cartList = $('#cartList'), cartSum = $('#cartSum');
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
    if (!cartList) return cart;
    cartList.innerHTML = cart.items.length ? cart.items.map(function (it, i) {
      return '<div class="cart-item"><span class="art art--photo">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</span>' +
        '<div><h4><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4><span class="mono">' + (it.variant_title ? esc(it.variant_title) + ' · ' : '') + 'Qty ' + it.quantity + ' · ' + money(it.final_line_price) + '</span></div>' +
        '<button class="x" type="button" data-rm="' + (i + 1) + '" aria-label="Remove ' + esc(it.product_title) + '"><svg aria-hidden="true"><use href="#x-close"/></svg></button></div>';
    }).join('') : '<p class="empty">Your bag is empty. The shop is a good place to start.</p>';
    cartSum.innerHTML = cart.items.length ? '<div class="row"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div><a class="btn btn--gold" href="/checkout">Checkout</a><p class="mono">Shipping calculated at checkout.</p>' : '';
    return cart;
  }
  function refreshCart() { return fetch(OF.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  if (cartList) {
    cartList.addEventListener('click', function (e) {
      var r = e.target.closest('[data-rm]'); if (!r) return;
      fetch(OF.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +r.dataset.rm, quantity: 0 }) })
        .then(function (res) { return res.json(); }).then(renderCart);
    });
  }
  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(function () { open($('#cDrawer')); }); });
  refreshCart();

  /* Product form */
  $$('form.pform').forEach(function (f) {
    var msg = $('[data-form-msg]', f), btn = $('button[type="submit"]', f);
    var select = $('select[name="id"]', f), priceEl = $('[data-price]');
    if (select && priceEl) select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex];
      priceEl.textContent = o.dataset.price;
      btn.disabled = o.disabled; btn.textContent = o.disabled ? 'Sold out' : 'Add to bag';
      if (buyNow) buyNow.disabled = o.disabled;
    });
    var buyNow = $('[data-buy-now]', f);
    if (buyNow) buyNow.addEventListener('click', function () {
      buyNow.disabled = true; if (msg) msg.textContent = '';
      fetch(OF.routes.add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { buyNow.disabled = false; if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not start checkout. Please try again.'; });
    });
    var val = $('[data-qty]', f), minus = $('[data-qminus]', f), plus = $('[data-qplus]', f);
    if (val) {
      minus.addEventListener('click', function () { val.value = Math.max(1, +val.value - 1); });
      plus.addEventListener('click', function () { val.value = Math.min(99, +val.value + 1); });
    }
    var gift = $('[data-gift]', f), note = $('[data-gift-note]', f);
    if (gift) gift.addEventListener('change', function () { note.hidden = !gift.checked; note.disabled = !gift.checked; });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (msg) msg.textContent = '';
      btn.disabled = true;
      fetch(OF.routes.add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { open($('#cDrawer')); })
        .catch(function (err) { if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add this piece. Please try again.'; })
        .then(function () { btn.disabled = false; });
    });
  });

  /* Product gallery */
  var galMain = $('[data-gal-main]');
  var varSel = $('#variantSel');
  $$('[data-gal]').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('[data-gal]').forEach(function (x) { x.setAttribute('aria-pressed', x === t); });
      galMain.src = t.dataset.gal; galMain.removeAttribute('srcset'); galMain.alt = t.dataset.alt || '';
      if (varSel && t.dataset.variant) varSel.value = t.dataset.variant;
    });
  });

  if (varSel) varSel.addEventListener("change", function () { var t = $("[data-gal][data-variant=\"" + varSel.value + "\"]"); if (t) t.click(); });

  /* Wishlist and recently viewed */
  var wish = load('of-wish');
  function paintWish() {
    var ids = wish.map(function (w) { return w.h; });
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', ids.indexOf(b.dataset.wish) >= 0); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = wish.length; });
    var box = $('#wishList'); if (!box) return;
    box.innerHTML = wish.length ? wish.map(function (w) {
      return '<div class="cart-item"><span class="art art--photo">' + (w.i ? '<img src="' + esc(w.i) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</span>' +
        '<div><h4><a href="' + esc(w.u) + '">' + esc(w.t) + '</a></h4><span class="mono">' + esc(w.p) + '</span></div>' +
        '<button class="x" type="button" data-unwish="' + esc(w.h) + '" aria-label="Remove ' + esc(w.t) + '"><svg aria-hidden="true"><use href="#x-close"/></svg></button></div>';
    }).join('') : '<p class="empty">Tap the heart on any piece to save it here.</p>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (b) {
      var i = wish.findIndex(function (w) { return w.h === b.dataset.wish; });
      if (i >= 0) wish.splice(i, 1); else { wish.push({ h: b.dataset.wish, t: b.dataset.t, p: b.dataset.p, i: b.dataset.i, u: b.dataset.u }); }
      save('of-wish', wish); paintWish();
    }
    var un = e.target.closest('[data-unwish]');
    if (un) { wish = wish.filter(function (w) { return w.h !== un.dataset.unwish; }); save('of-wish', wish); paintWish(); }
    var hear = e.target.closest('[data-hear]');
    if (hear && hear.dataset.src) {
      var bowlSound = hear._sound || (hear._sound = S.track(new Audio(hear.dataset.src)));
      if (bowlSound.paused) { S.route(bowlSound); bowlSound.currentTime = 0; bowlSound.play(); } else { bowlSound.pause(); }
    } else if (hear && S) S.clip(+hear.dataset.hz || 342.88, 14);
  });
  var wishBtn = $('#wishBtn'); if (wishBtn) wishBtn.addEventListener('click', function () { paintWish(); open($('#wDrawer')); });
  paintWish();

  var pdp = $('[data-pdp]'), recent = load('of-recent');
  if (pdp) {
    recent = [{ h: pdp.dataset.h, t: pdp.dataset.t, p: pdp.dataset.p, i: pdp.dataset.i, u: pdp.dataset.u }].concat(recent.filter(function (r) { return r.h !== pdp.dataset.h; })).slice(0, 8);
    save('of-recent', recent);
  }
  $$('[data-recent]').forEach(function (box) {
    var list = recent.filter(function (r) { return !pdp || r.h !== pdp.dataset.h; }).slice(0, 6);
    if (!list.length) return;
    box.innerHTML = '<span class="label">Recently viewed</span><div class="row">' + list.map(function (r) {
      return '<a class="obj" href="' + esc(r.u) + '"><span class="art art--photo">' + (r.i ? '<img src="' + esc(r.i) + '" alt="" loading="lazy" width="240" height="300">' : '') + '</span><h3>' + esc(r.t) + '</h3><span class="meta mono"><span class="price">' + esc(r.p) + '</span></span></a>';
    }).join('') + '</div>';
  });

  /* Recommendations */
  $$('[data-recs]').forEach(function (box) {
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), inner = $('[data-recs]', doc);
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; paintWish(); }
    }).catch(function () {});
  });

  /* Hero cabinet */
  $$('[data-cabinet]').forEach(function (cab) {
    var panels = $$('.cab-panel', cab), tabs = $$('.cab-tab', cab), i = 0, timer = null;
    if (!panels.length) return;
    function show(n, manual) {
      i = n;
      panels.forEach(function (p, k) { p.classList.toggle('on', k === n); p.setAttribute('aria-hidden', k !== n); });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === n); });
      if (manual) { cab.classList.add('manual'); clearInterval(timer); }
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k, true); }); });
    requestAnimationFrame(function () { show(0); });
    if (!still && panels.length > 1) timer = setInterval(function () { if (!document.hidden) show((i + 1) % panels.length); }, 4500);
  });

  /* Materials tabs */
  $$('[data-tabs]').forEach(function (box) {
    var tabs = $$('.tab', box), panels = $$('.mat', box);
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === k); });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
      });
    });
  });

  /* Catalogue scroller */
  $$('[data-track]').forEach(function (sec) {
    var tw = $('.track-wrap', sec), bar = $('.progress i', sec);
    function prog() {
      var max = tw.scrollWidth - tw.clientWidth, w = Math.max(10, tw.clientWidth / Math.max(1, tw.scrollWidth) * 100);
      bar.style.width = w + '%'; bar.style.left = (max > 0 ? tw.scrollLeft / max * (100 - w) : 0) + '%';
    }
    tw.addEventListener('scroll', prog, { passive: true }); window.addEventListener('resize', prog); prog();
    $('[data-prev]', sec).addEventListener('click', function () { tw.scrollBy({ left: -tw.clientWidth * .8, behavior: 'smooth' }); });
    $('[data-next]', sec).addEventListener('click', function () { tw.scrollBy({ left: tw.clientWidth * .8, behavior: 'smooth' }); });
  });

  /* Top sound buttons. Sound starts only after a visitor taps, which is a browser rule. */
  var soundBtn = $('#soundBtn'), birdBtns = $$('[data-bird-toggle]');
  if (soundBtn && S) {
    soundBtn.addEventListener('click', function () {
      var off = soundBtn.getAttribute('aria-pressed') !== 'true';
      S.setMuted(off);
      soundBtn.setAttribute('aria-pressed', off);
      soundBtn.setAttribute('aria-label', off ? 'Turn sound on' : 'Mute sound');
      soundBtn.title = off ? 'Turn sound on' : 'Mute sound';
      $('use', soundBtn).setAttribute('href', off ? '#x-mute' : '#x-sound');
    });
  }
  if (S) birdBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-pressed') !== 'true';
      S.birds(on);
      birdBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', on);
        b.setAttribute('aria-label', on ? 'Stop bird sounds' : 'Play bird sounds');
        b.title = on ? 'Stop bird sounds' : 'Play bird sounds';
      });
    });
  });
  /* Volume controls beside the bowls */
  var volRanges = $$('[data-vol-range]');
  function showVolume() {
    var pct = Math.round(S.getVolume() * 100);
    volRanges.forEach(function (r) { r.value = pct; });
    $$('[data-vol-read]').forEach(function (r) { r.textContent = pct + '%'; });
  }
  if (S && volRanges.length) {
    showVolume();
    volRanges.forEach(function (r) { r.addEventListener('input', function () { S.setVolume(r.value / 100); showVolume(); }); });
    $$('[data-vol-step]').forEach(function (b) { b.addEventListener('click', function () { S.setVolume(S.getVolume() + (+b.dataset.volStep)); showVolume(); }); });
  }

  /* Sound room */
  if (S) $$('[data-bowl-room]').forEach(function (r) { S.mountBowl(r); });

  /* Singing bowl shop: filters, note buttons and a player on each bowl */
  var activeTone = null;
  function stopTone() { if (activeTone) { activeTone.stop(); activeTone = null; } }
  var clock = function (s) { s = Math.max(0, Math.ceil(s)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); };
  $$('.tone').forEach(function (t) {
    var btn = $('.tone-btn', t), bar = $('.tone-bar i', t), time = $('.tone-time', t), dur = +t.dataset.dur || 12;
    var audio = t.dataset.src ? S.track(new Audio(t.dataset.src)) : null;
    btn.addEventListener('click', function () {
      var mine = activeTone && activeTone.el === t;
      stopTone();
      if (mine) return;
      var length = audio && isFinite(audio.duration) && audio.duration ? audio.duration : dur;
      var stopSound = function () {};
      if (audio) { S.route(audio); audio.currentTime = 0; audio.play(); stopSound = function () { audio.pause(); }; }
      else if (S) stopSound = S.clip(+t.dataset.hz, dur);
      var start = performance.now(), raf = 0;
      t.classList.add('on'); btn.setAttribute('aria-pressed', 'true');
      activeTone = { el: t, stop: function () { stopSound(); cancelAnimationFrame(raf); t.classList.remove('on'); btn.setAttribute('aria-pressed', 'false'); bar.style.width = '0'; time.textContent = clock(length); } };
      (function tick(now) {
        var left = length - (now - start) / 1000;
        if (left <= 0) { stopTone(); return; }
        bar.style.width = (100 - left / length * 100) + '%'; time.textContent = clock(left);
        raf = requestAnimationFrame(tick);
      })(start);
    });
  });
  $$('[data-bowl-shop]').forEach(function (shop) {
    var filters = $$('.bs-filter', shop), cards = $$('.bs-card', shop), notes = $$('[data-note]', shop);
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        filters.forEach(function (x) { x.setAttribute('aria-pressed', x === f); });
        notes.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        stopTone();
        cards.forEach(function (c) { c.hidden = f.dataset.type !== 'all' && c.dataset.kind !== f.dataset.type; });
      });
    });
    // A note opens the bowls tagged with it, such as note:F. With no tagged bowls yet, the list stays blank.
    notes.forEach(function (n) {
      n.addEventListener('click', function () {
        stopTone();
        notes.forEach(function (x) { x.setAttribute('aria-pressed', x === n); });
        filters.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        cards.forEach(function (c) { c.hidden = (c.dataset.notes || '').split(' ').indexOf(n.dataset.letter) < 0; });
      });
    });
  });

  /* Fade sections in on scroll */
  if (!still && 'IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (list) {
      list.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; seen.unobserve(el); el.classList.add('in');
        setTimeout(function () { el.classList.remove('reveal', 'in'); }, 900);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.sec-head, .hero3-tile, .col-tile, .learn-item, .hemp-grid, .craft-grid, .play-steps, .ticket').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('reveal'); seen.observe(el);
    });
  }

  /* Wholesale request sent */
  var wsSent = $('[data-ws-sent]');
  if (wsSent && /[?&]sent=1/.test(location.search)) { wsSent.hidden = false; wsSent.scrollIntoView({ block: 'center' }); }

  /* Wholesale request: also save the business as a tagged customer, so an automated email can send the list */
  var wsForm = $('form.ws-request');
  if (wsForm) wsForm.addEventListener('submit', function () {
    var data = new URLSearchParams();
    data.set('form_type', 'customer');
    data.set('utf8', '\u2713');
    data.set('contact[email]', $('#wsEmail').value);
    data.set('contact[first_name]', $('#wsName').value);
    data.set('contact[tags]', 'wholesale');
    fetch('/contact', { method: 'POST', body: data, keepalive: true }).catch(function () {});
  });

  /* Gift finder */
  $$('[data-finder]').forEach(function (sec) {
    var data = [], ans = { who: 'me', mood: 'ritual', budget: 'mid' };
    try { data = JSON.parse($('script[type="application/json"]', sec).textContent); } catch (err) {}
    var result = $('.result', sec);
    function paint() {
      var mats = { ritual: ['metal', 'stone', 'tea'], wood: ['wood', 'fiber'], care: ['bamboo', 'tea', 'pet', 'hemp'] }[ans.mood];
      var inB = function (p) { return ans.budget === 'low' ? p.p < 4000 : ans.budget === 'mid' ? p.p >= 4000 && p.p <= 9000 : p.p > 9000; };
      var pool = data.filter(function (p) { return p.a && mats.indexOf(p.m) >= 0; }), picks = pool.filter(inB), near = false;
      if (!picks.length) { picks = pool.slice().sort(function (a, b) { return a.p - b.p; }); near = true; }
      var who = ans.who === 'gift' ? 'for them' : 'for you';
      var head = { ritual: 'A ritual object ' + who, wood: 'A carving with character, ' + who, care: 'Something for every day, ' + who }[ans.mood];
      result.innerHTML = '<span class="label">Our suggestion</span><h3>' + head + '</h3>' + (near && picks.length ? '<p class="mono">Nothing in that range right now. Here is the closest we have.</p>' : '') +
        (picks.length ? '<div class="result-items">' + picks.slice(0, 2).map(function (p) {
          return '<a class="obj" href="' + esc(p.u) + '"><span class="art art--photo">' + (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="360" height="450">' : '') + '</span><h3>' + esc(p.t) + '</h3><span class="meta mono"><span class="price">' + money(p.p) + '</span></span></a>';
        }).join('') + '</div>' : '<p class="lead">Our newest pieces are in the store. Come and see them at the house.</p>');
    }
    $$('.opts', sec).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.opt'); if (!b) return;
        $$('.opt', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        ans[g.dataset.q] = b.dataset.v; paint();
      });
    });
    paint();
  });

  /* Collection filters submit themselves */
  $$('form[data-filters]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });

  /* Magnetic buttons */
  if (fine && !still) {
    document.addEventListener('mousemove', function (e) {
      var b = e.target.closest('.btn, .arrow, .tune');
      $$('.mag').forEach(function (m) { if (m !== b) { m.classList.remove('mag'); m.style.transform = ''; } });
      if (!b) return;
      var r = b.getBoundingClientRect(); b.classList.add('mag');
      b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * .3).toFixed(1) + 'px)';
    });
  }

  /* Depth on scroll */
  if (!still) {
    var parEls = $$('[data-par]'), ticking = false;
    var parallax = function () {
      var vh = window.innerHeight;
      parEls.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
        el.style.transform = 'translateY(' + ((r.top + r.height / 2 - vh / 2) * +el.dataset.par).toFixed(1) + 'px)';
      });
      ticking = false;
    };
    if (parEls.length) { window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true }); parallax(); }
  }
})();
